export default "__VITE_ASSET__0fa30091__"